<script lang="ts" setup>
import { ref, onMounted } from "vue";
import CommonVTimeLineCorousel from "@/components/common/VTimeLineCorousel.vue";
import { getSiteData } from "@/NavigationHelper";
import { checkBegriff } from "@/local";
const props = defineProps<{
  aic?: number;
}>();
interface TimelinesComponent {
  onRefresh: () => void;
}
let gotoDate = ref<Date | null>(null);
let initalized = ref<boolean>(false);
let showManZulagen = ref<boolean>(false);

onMounted(() => {
  // eigenes Modul für manuelle ZulagenErfassung
  if (checkBegriff("PZE_WEB_persManZulagenerfassung")) {
    showManZulagen.value = true;
  }
  const siteData = getSiteData();
  if (siteData?.goDate) {
    gotoDate.value = siteData.goDate;
  } else {
    const fromStorage = window.localStorage.getItem("timelineDate");
    if (isValidDateString(fromStorage)) {
      gotoDate.value = new Date(fromStorage);
    }
  }
  initalized.value = true;
});
const timelines = ref<TimelinesComponent | null>(null);
function onRefresh() {
  if (timelines.value && typeof timelines.value.onRefresh === "function") {
    timelines.value.onRefresh(); // Accessing the onRefresh method safely
  }
}
function toIsoDateString(d: any): string {
  if (!d) return "";
  const date = d instanceof Date ? d : new Date(d);
  return date.toISOString(); // alternativ nur YYYY-MM-DD extrahieren, wenn Tagesgenau reicht
}

function isValidDateString(s: any): s is string {
  return typeof s === "string" && !Number.isNaN(Date.parse(s));
}

function setGoDate(goDate: any) {
  gotoDate.value = goDate;
  const iso = toIsoDateString(goDate);
  if (!iso) return;
  window.localStorage.setItem("timelineDate", iso);
}
</script>
<template>
  <CommonVTimeLineCorousel
    v-if="initalized"
    ref="timelines"
    :daysBack="90"
    :daysForward="0"
    query="WebStempelungenSoftTerm"
    :showError="true"
    :showTagessaldo="true"
    :showNacherfassung="true"
    :showProjektstunden="true"
    :showReisekosten="true"
    :goDate="gotoDate"
    queryEdit="Web_TimeLineStempelungen"
    @gotoDate="setGoDate"
    :showManZulagen="showManZulagen"
  ></CommonVTimeLineCorousel>
</template>
<style scoped></style>
